<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="650px"
    class="migration-notice-dialog"
    :close-on-click-modal="false"
    :show-close="true"
    :center="true"
    :append-to-body="true"
  >
    <!-- 自定义标题区域 -->
    <div slot="title" class="custom-title">
      <i
        class="el-icon-message-solid"
        style="color: #762ADB; font-size: 24px; margin-right: 8px;"
      ></i>
      <span>系统提示</span>
    </div>

    <!-- 内容区域 -->
    <div class="notice-content" style="line-height: 1.8; color: #606266;">
      <p style="margin-bottom: 10px; font-weight: bold; color: #E6A23C;">
        为了提供更好的服务，本系统将于 2026年3月23日 进行功能迁移。
      </p>
      <p style="margin-bottom: 10px;">
        在此之后，本系统操作将切换至新系统地址进行。给您造成的不便敬请谅解。
      </p>

      <!-- 新系统地址卡片 -->
      <div
        style="background: #f4f4f5; padding: 12px; border-radius: 4px; margin: 12px 0;"
      >
        <p
          style="margin: 0 0 8px 0; font-weight: bold; display: flex; align-items: center;"
        >
          <img
            src="~@/assets/images/xs.png"
            style="width: 20px; height: 20px; margin-right: 4px;"
          />
          <span>新系统地址：</span>
        </p>
        <a
          href="https://tms.ytoglobal.com/"
          target="_blank"
          style="color: #762ADB; text-decoration: none; word-break: break-all;"
        >
          https://tms.ytoglobal.com/
        </a>

        <p
          style="margin: 12px 0 8px 0; font-weight: bold; display: flex; align-items: center;"
        >
          <img
            src="~@/assets/images/suo.png"
            style="width: 20px; height: 20px; margin-right: 4px;"
          />
          <span>登录方式：</span>
        </p>
        <p style="margin: 4px 0;">• 扫码登录• 手机验证码• 用户名密码（用户名不变，密码提前短信发送）</p>
        <p style="margin: 4px 0;"></p>
        <p style="margin: 4px 0;">

        </p>
      </div>

      <!-- 注意事项卡片 -->
      <div
        style="background: #fdf6ec; border-left: 4px solid #E6A23C; padding: 10px; margin: 12px 0;"
      >
        <!-- <img  src="~@/assets/images/jg.png"> -->
        <p style="margin: 0; color: #E6A23C; font-weight: bold;">
          ⚠️ 注意事项：
        </p>
        <p style="margin: 8px 0 0 0; color: #E6A23C;">
          请您在 2026年3月22日
          前及时登录新系统，确认您的功能及权限是否使用正常。
        </p>
      </div>

      <!-- 联系人信息 -->
      <div
        style="margin-top: 18px; padding-top: 14px; border-top: 1px dashed #dcdfe6;"
      >
        <p style="margin: 0 0 10px 0; font-size: 15px; font-weight: 500;">
          感谢您的理解与配合。
        </p>
        <p style="margin: 0 0 10px 0; color: #606266; font-size: 15px;">
          若遇到任何问题，请及时联系：
        </p>
        <div style="margin-top: 10px; line-height: 2.2;">
          <p style="margin: 0; font-size: 15px;">
            您的客户经理或钉钉联系
            <span style="font-weight: bold; color: #303133;">杨占魁</span>
            <span style="color: #606266;">（03439530）</span>
            <span style="font-weight: bold; color: #303133;">田文洁</span>
            <span style="color: #606266;">（03500104）</span>进行处理。
          </p>
        </div>
      </div>
    </div>

    <!-- 底部按钮 -->
    <span
      slot="footer"
      class="dialog-footer"
      style="display: flex; justify-content: end;"
    >
      <el-button
        type="reset"
        style="background: #fff; border-color: #EDEEF1; color: #514E55;"
        @click="dialogVisible = false"
      >
        取消
      </el-button>
      <el-button
        type="primary"
        @click="handleJump"
        style="background: #762ADB; border-color: #762ADB;"
      >
        立即跳转
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "MigrationNoticeDialog",
  data() {
    return {
      dialogVisible: false
    };
  },
  computed: {
    showCloseButton() {
      const currentDate = new Date();
      const targetDate = new Date("2026-04-01");
      console.log('currentDate', currentDate)

      // 如果当前时间在2026年4月1日之前，返回true（显示关闭按钮）
      // 否则返回false（隐藏关闭按钮）
      return currentDate < targetDate;
    }
  },
  methods: {
    show() {
      this.dialogVisible = true;
    },
    handleJump() {
      // 关闭弹窗
      this.dialogVisible = false;

      // 跳转到指定URL
      window.location.href = 'https://tms.ytoglobal.com/';

      // 或者使用以下方式在新标签页打开
      // window.open('https://tms.ytoglobal.com/', '_blank');
    }
  }
};
</script>

<style scoped>
.custom-title {
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: bold;
}

.notice-content {
  padding: 0 10px;
}
</style>

<style>
/* 全局样式，确保弹框居中 */
.migration-notice-dialog {
  display: flex;
  align-items: center;
  justify-content: center;
}

.migration-notice-dialog .el-dialog {
  margin: 0 auto !important;
}

/* 确保遮罩层也支持居中 */
.el-overlay {
  display: flex;
  align-items: center;
  justify-content: center;
}

.el-overlay .el-dialog {
  margin: 0 auto !important;
  position: relative;
  top: 0;
  transform: none;
}

/* 自定义弹框样式 */
.migration-notice-dialog .el-dialog__header {
  border-bottom: 1px solid #e8e8e8;
  padding: 20px 20px 10px;
}

.migration-notice-dialog .el-dialog__body {
  padding: 20px 20px 10px;
}

.migration-notice-dialog .el-dialog__footer {
  padding: 10px 20px 20px;
  border-top: none;
  text-align: center;
}

/* 隐藏默认的标题图标 */
.migration-notice-dialog .el-dialog__headerbtn {
  top: 20px;
  right: 20px;
}
</style>
